import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { brandInfo } from '@/mocks/home';

const teamMembers = [
  {
    name: '陈志远',
    role: '创始人 & CEO',
    bio: '拥有 15 年科技行业经验，曾任职多家世界 500 强企业高管，致力于用技术改变人们的生活方式。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20portrait%20in%20modern%20office%20setting%20clean%20studio%20lighting%20professional%20headshot%20confident%20expression&width=300&height=300&seq=team-01&orientation=squarish',
  },
  {
    name: '林雪婷',
    role: 'CTO',
    bio: '人工智能与大数据领域专家，多项国际专利持有者，带领技术团队持续打造行业领先的解决方案。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%20in%20modern%20tech%20office%20clean%20studio%20lighting%20professional%20headshot%20smart%20confident&width=300&height=300&seq=team-02&orientation=squarish',
  },
  {
    name: '黄伟强',
    role: 'COO',
    bio: '资深运营管理专家，擅长企业战略规划与组织效能提升，推动公司业务持续高速增长。',
    image: 'https://readdy.ai/api/search-image?query=Mature%20Chinese%20professional%20man%20portrait%20in%20corporate%20setting%20clean%20studio%20lighting%20professional%20headshot%20experienced%20leader&width=300&height=300&seq=team-03&orientation=squarish',
  },
  {
    name: '赵思琪',
    role: 'CMO',
    bio: '品牌营销领域深耕 10 年，打造多个行业标杆品牌案例，让 aiye 走进千家万户。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20female%20professional%20portrait%20in%20creative%20office%20clean%20studio%20lighting%20professional%20headshot%20friendly%20smile&width=300&height=300&seq=team-04&orientation=squarish',
  },
];

const milestones = [
  { year: '2018', title: '品牌创立', description: 'aiye 品牌正式成立，以「技术创新驱动品质生活」为使命开启征程。' },
  { year: '2019', title: '首款产品发布', description: '推出首款智能解决方案产品，获得首批 100 家企业客户认可。' },
  { year: '2020', title: 'A 轮融资', description: '完成 A 轮融资，团队规模扩展至 50 人，产品线拓展至三大领域。' },
  { year: '2021', title: '用户突破 10 万', description: '累计服务用户突破 10 万，产品覆盖全国 30+ 城市，品牌影响力持续扩大。' },
  { year: '2022', title: '技术突破', description: '核心技术取得重大突破，获得 47 项技术专利，产品性能提升 300%。' },
  { year: '2023', title: '生态布局', description: '构建开放平台生态，与 1000+ 合作伙伴建立深度合作，打造全链路解决方案。' },
  { year: '2024', title: '行业领先', description: '市场份额进入行业前三，服务用户突破 50 万，客户满意度达 98.6%。' },
  { year: '2025', title: '全球拓展', description: '启动全球化战略布局，产品和服务拓展至东南亚、欧洲等海外市场。' },
];

const faqs = [
  {
    q: 'aiye 提供哪些产品和服务？',
    a: 'aiye 提供智能解决方案、数据分析平台、云服务架构、安全防护体系、物联网平台和企业协同工具等六大核心产品线，覆盖企业数字化的各个关键环节。',
  },
  {
    q: '如何获取 aiye 产品的试用？',
    a: '您可以通过我们的联系表单提交试用申请，或直接拨打客服热线。我们的专业团队将在 24 小时内与您联系，为您开通专属试用账号。',
  },
  {
    q: 'aiye 的产品价格是怎样的？',
    a: 'aiye 采用灵活的定价策略，根据企业规模、使用场景和功能需求提供定制化方案。请联系我们的销售团队获取详细报价。',
  },
  {
    q: 'aiye 提供哪些技术支持？',
    a: '我们提供 7×24 小时全天候技术支持，包括在线客服、电话支持、远程协助和现场服务等多种方式，确保您的问题得到及时专业的解决。',
  },
  {
    q: '数据安全如何保障？',
    a: 'aiye 采用银行级数据加密、多重身份认证、实时安全监控等多层防护机制，并已通过多项国际安全认证，全面保障您的数据安全与隐私。',
  },
];

export default function AboutPage() {
  const location = useLocation();
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }
    setFormStatus('submitting');
    setFormError('');
    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9snkth4ne17ei0sdkjg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        if (msg.includes('spam')) {
          setFormStatus('error');
          setFormError('提交失败，请稍后重试');
        } else {
          setFormStatus('error');
          setFormError(msg);
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-28 pb-10 md:pt-32 md:pb-14 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-6">
              <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-900">关于我们</span>
            </nav>
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              关于 aiye
            </h1>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl leading-relaxed">
              {brandInfo.description}
            </p>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
              <div>
                <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-4">
                  品牌故事
                </span>
                <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                  以技术创新驱动品质生活
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    aiye 成立于 2018 年，由一群怀揣技术梦想的年轻人共同创立。我们深知，在数字化浪潮席卷全球的今天，技术不应只是冰冷的代码，更应成为温暖人心的力量。
                  </p>
                  <p>
                    从最初的几人小团队，到如今数百人的专业科技公司，aiye 始终秉持着「用户至上、创新驱动」的核心理念。我们相信，每一个产品都应该真正解决用户的问题，每一项技术都应该为美好生活赋能。
                  </p>
                  <p>
                    经过多年的深耕与积累，aiye 已经构建了涵盖智能解决方案、数据分析、云服务、安全防护、物联网和协同工具在内的六大产品矩阵，累计服务了超过 50 万用户，成为行业内的标杆品牌。
                  </p>
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20interior%20with%20warm%20natural%20lighting%20team%20collaboration%20space%20clean%20aesthetic%20terracotta%20and%20cream%20accents%20professional%20corporate%20environment&width=600&height=400&seq=about-story&orientation=landscape"
                  alt="aiye 办公环境"
                  className="w-full aspect-[3/2] object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-4">
                发展历程
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                aiye 的成长足迹
              </h2>
            </div>
            <div className="relative max-w-3xl mx-auto">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
              <div className="space-y-8 md:space-y-10">
                {milestones.map((m, idx) => (
                  <div
                    key={m.year}
                    className={`relative flex items-start gap-6 md:gap-10 ${
                      idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                    }`}
                  >
                    <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                      <div className="bg-background-50 border border-background-200/70 rounded-xl p-5">
                        <span className="text-xs font-bold text-primary-600">{m.year}</span>
                        <h3 className="text-base font-heading font-semibold text-foreground-950 mt-1 mb-1">
                          {m.title}
                        </h3>
                        <p className="text-sm text-foreground-500 leading-relaxed">{m.description}</p>
                      </div>
                    </div>
                    <div className="hidden md:flex flex-1"></div>
                    <div className="absolute left-[11px] md:left-1/2 w-3 h-3 rounded-full bg-accent-500 border-2 border-background-50 md:-translate-x-1.5 mt-2"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold tracking-wide mb-4">
                核心团队
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                遇见 aiye 团队
              </h2>
              <p className="mt-2 text-foreground-500 text-sm">
                一群热爱技术、追求卓越的伙伴
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {teamMembers.map((member) => (
                <div
                  key={member.name}
                  className="text-center p-6 rounded-2xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="w-24 h-24 mx-auto rounded-full overflow-hidden mb-4">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-950">{member.name}</h3>
                  <p className="text-xs text-primary-600 font-medium mt-0.5 mb-3">{member.role}</p>
                  <p className="text-xs text-foreground-500 leading-relaxed">{member.bio}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-4">
                常见问题
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                您可能想了解
              </h2>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {faqs.map((faq, idx) => (
                <details
                  key={idx}
                  className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
                >
                  <summary className="flex items-center justify-between p-5 cursor-pointer text-sm md:text-base font-medium text-foreground-900 hover:text-primary-600 transition-colors list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16">
              <div>
                <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-4">
                  联系我们
                </span>
                <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
                  与 aiye 取得联系
                </h2>
                <p className="text-sm text-foreground-500 leading-relaxed mb-8">
                  无论您有任何疑问、建议还是合作意向，我们都非常期待与您交流。填写表单，我们将在 24 小时内回复。
                </p>
                <div className="space-y-4">
                  {[
                    { icon: 'ri-map-pin-line', label: '公司地址', value: '中国上海市浦东新区科技园区 aiye 大厦' },
                    { icon: 'ri-mail-line', label: '电子邮箱', value: 'contact@aiye.com' },
                    { icon: 'ri-phone-line', label: '客服热线', value: '400-888-9999' },
                    { icon: 'ri-time-line', label: '工作时间', value: '周一至周五 9:00 - 18:00' },
                  ].map((item) => (
                    <div key={item.label} className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`${item.icon} text-primary-600 text-sm`}></i>
                      </div>
                      <div>
                        <div className="text-xs text-foreground-400 mb-0.5">{item.label}</div>
                        <div className="text-sm font-medium text-foreground-900">{item.value}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-8">
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-6">
                  发送消息
                </h3>
                <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form="">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-xs font-medium text-foreground-600 mb-1.5">姓名 *</label>
                      <input
                        type="text"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-foreground-600 mb-1.5">邮箱 *</label>
                      <input
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-foreground-600 mb-1.5">公司</label>
                    <input
                      type="text"
                      name="company"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的公司名称"
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-foreground-600 mb-1.5">咨询类型</label>
                    <select
                      name="inquiry_type"
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                    >
                      <option value="">请选择咨询类型</option>
                      <option value="product">产品咨询</option>
                      <option value="cooperation">商务合作</option>
                      <option value="support">技术支持</option>
                      <option value="other">其他</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-xs font-medium text-foreground-600 mb-1.5">留言内容 *</label>
                    <textarea
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言内容（最多500字）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="absolute opacity-0 pointer-events-none"
                    style={{ position: 'absolute', left: '-9999px' }}
                  />
                  <button
                    type="submit"
                    disabled={formStatus === 'submitting'}
                    className="w-full py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 disabled:opacity-60 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {formStatus === 'submitting' ? '提交中...' : '发送消息'}
                  </button>
                  {formStatus === 'success' && (
                    <p className="text-sm text-green-600 text-center">消息已发送，感谢您的咨询！我们将尽快回复。</p>
                  )}
                  {formStatus === 'error' && (
                    <p className="text-sm text-red-500 text-center">{formError}</p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: { '@type': 'Answer', text: faq.a },
            })),
          }),
        }}
      />
    </>
  );
}